import { Routes } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./main/main.component').then((m) => m.MainComponent),
      },
      {
        path: 'review',
        loadComponent: () =>
          import('./review/review.component').then((m) => m.ReviewComponent),
      },
      {
        path: 'timesheets',
        loadComponent: () =>
          import('./timesheets/timesheets').then(
            (m) => m.Timesheets,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./settings/settings').then(
            (m) => m.Settings,
          ),
        canActivate: [MsalGuard],
      },
    ]
  },
  {
    path: 'auth',
    component: MsalRedirectComponent
  },
  {
    path: 'login-failed',
    loadComponent: () => import('./login-failed/login-failed.component').then(m => m.LoginFailedComponent)
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./not-found/not-found').then((m) => m.NotFound),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
